export default "__VITE_ASSET__xhOsK6Oh__"